var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification_x5F_success"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,0C3.589,0,0,3.589,0,8c0,4.411,3.589,8,8,8c4.411,0,8-3.589,8-8C16,3.589,12.411,0,8,0z M14.713,8 c0,3.702-3.011,6.713-6.713,6.713c-3.702,0-6.713-3.011-6.713-6.713c0-3.702,3.012-6.713,6.713-6.713 C11.702,1.287,14.713,4.298,14.713,8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.617,5.473L6.928,9.162L5.383,7.617c-0.243-0.243-0.667-0.243-0.91,0C4.352,7.738,4.285,7.9,4.285,8.072 c0,0.172,0.067,0.333,0.189,0.455l2,2c0.122,0.122,0.283,0.189,0.455,0.189c0.172,0,0.333-0.067,0.455-0.189l4.144-4.144 c0.122-0.122,0.189-0.283,0.189-0.455c0-0.172-0.067-0.333-0.189-0.455C11.284,5.23,10.86,5.23,10.617,5.473z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSuccess);
export default __webpack_public_path__ + "static/media/notificationSuccess.abac6558f59c93e37182cbdbddb6eb3d.svg";
export { ForwardRef as ReactComponent };